"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.badgeVariants = exports.Badge = void 0;
const class_variance_authority_1 = require("class-variance-authority");
const clsx_1 = __importDefault(require("clsx"));
const react_1 = __importDefault(require("react"));
// Define the badge variants with  prefix
const badgeVariants = (0, class_variance_authority_1.cva)("inline-flex items-center px-2.5 py-0.5 text-sm font-medium rounded-full transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500", {
    variants: {
        variant: {
            default: "bg-blue-500 text-white",
            secondary: "bg-grey500 text-white",
            outline: "border border-grey300 text-grey900",
            destructive: "bg-red-500 text-white",
        },
    },
    defaultVariants: {
        variant: "default",
    },
});
exports.badgeVariants = badgeVariants;
// Badge component
exports.Badge = react_1.default.forwardRef(({ className, variant, ...props }, ref) => {
    return (react_1.default.createElement("span", { ref: ref, className: (0, clsx_1.default)(badgeVariants({ variant }), className), ...props }));
});
exports.Badge.displayName = "Badge";
